export const FETCH_INVOICE_REQUEST = 'FETCH_INVOICE_REQUEST';
export const FETCH_INVOICE_SUCCESS = 'FETCH_INVOICE_SUCCESS';
export const FETCH_INVOICE_FAILURE = 'FETCH_INVOICE_FAILURE';
export const PATCH_INVOICE_REQUEST = 'PATCH_INVOICE_REQUEST';
export const PATCH_INVOICE_SUCCESS = 'PATCH_INVOICE_SUCCESS';
export const PATCH_INVOICE_FAILURE = 'PATCH_INVOICE_FAILURE';